import React from 'react'
import Name from './name'
import Grade from './grade'
import Biography from './biography'
import Interests from '../../user-interests/section'
import Goals from '../../goals/section'
import UserReflections from '../../user-reflections/section'
import useUser from '../../../hooks/use-user'
import SpinnerContainer from '../../common/spinner-container'
import UserRole from '../role-field'
import EnrolledCourses from '../enrolled-courses'
import StudentId from './student-id'
import Email from '../email'

const ProfileRow = ({
    children,
    style = {}
}) => {
    return (
        <div style={{
            ...style,
            paddingLeft: '40px',
            paddingRight: '40px',
            paddingBottom: '15px',
            paddingTop: '15px'
        }}>
            {children}
        </div>
    )
}

const ProfileCompact = ({
    userId
}) => {

    const {
        isBusy,
        user,
        isStudent
    } = useUser({ id: userId })

    if (isBusy) {
        return (<SpinnerContainer />)
    }

    const renderStudentInfo = () => {
        if (!isStudent) {
            return null
        }

        return (
            <div>
                <ProfileRow style={{ backgroundColor: 'rgb( 241, 249, 255)' }}>
                    <Interests userId={userId} />
                </ProfileRow>
                <ProfileRow>
                    <Goals userId={userId} />
                </ProfileRow>
                <ProfileRow style={{ backgroundColor: 'rgb( 241, 249, 255)' }}>
                    <UserReflections userId={userId}  />
                </ProfileRow>
                <ProfileRow>
                    <EnrolledCourses userId={userId} />
                </ProfileRow>
            </div>
        )
    }

    return (
        <div style={{ height: '100%', paddingTop: '40px'}}>
            <div style={{ overflowY: 'auto', height: '100%' }}>
                <ProfileRow>
                    <div><Name user={user} /></div>
                    <div><UserRole user={user} /></div>
                    <div><Grade user={user} /></div>
                    <div><Email user={user} /></div>
                    <div><StudentId user={user} /></div>
                    <div style={{ paddingTop: '20px'}}><Biography user={user} /></div>
                </ProfileRow>
                {renderStudentInfo()}
            </div>
        </div>
    )
}

export default ProfileCompact